import { AttendanceServiceEnum } from "../../attendance/enums/attendance-cau.enum";

export class ServiceStudentAttendanceMonitorResponse {
    exerciseId: number;
    year: number;
    month: number;
    day: number;
    schoolId: number;
    schoolName: string;
    isHoliday: boolean; 
    serviceAttendanceMonitor: ServiceAttendanceMonitorResponse[];
}

export class ServiceAttendanceMonitorResponse {
    serviceId: number;
    serviceName: string;
    userValidation: string;
    dateValidation: Date;
    studentAttendanceMonitor: StudentAttendanceMonitorResponse[]
}

export class StudentAttendanceMonitorResponse {
    studentId: number;
    studentCau: string;
    studentName: string;
    studentSurname: string;
    studentSecondSurname: string;
    schoolarCourse: string;
    schoolarCourseId: number;
    attendanceState: AttendanceServiceEnum;
    attendanceService: number;
    schoolarshipId: number;
    schoolarshipName: string;
    edited: boolean;
}

export class StudentsAttendancesValidateMonitorRequest {
    //exerciseId: number;
    year: number;
    month: number;
    day: number;
    schoolId: number;
    serviceId: number;  
    isHoliday: boolean;   
    attendanceStudent: StudentAttendanceValidateMonitorRequest[];
}

export class StudentAttendanceValidateMonitorRequest {
    studentId: number;
    attendanceService: number;
}